var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("footer", { staticClass: "footer" }, [
        _vm.showSearch
          ? _c("div", { staticClass: "footTitle" }, [
              _vm._m(0),
              _c("div", { staticClass: "footTitleRight" }),
            ])
          : _c(
              "div",
              {
                staticStyle: {
                  "margin-bottom": "10px",
                  "text-align": "center",
                  display: "flex",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-right": "2rem" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { padding: "0.1rem 0.2" },
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addCollection1()
                          },
                        },
                      },
                      [_vm._v("生成新的收款确认单")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { padding: "0.1rem", width: "5rem" },
                        attrs: {
                          size: "mini",
                          type: _vm.dialogVisible1 ? "" : "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handlerSeeOrderClick1()
                          },
                        },
                      },
                      [_vm._v("已生成的操作及收费确认单")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { padding: "0.1rem", width: "5rem" },
                        attrs: {
                          size: "mini",
                          type: _vm.dialogVisible1 ? "primary" : "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handlerSeeOrderClick1()
                          },
                        },
                      },
                      [_vm._v("收款列表")]
                    ),
                  ],
                  1
                ),
              ]
            ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.dialogVisible1,
                expression: "!dialogVisible1",
              },
            ],
            staticStyle: { border: "1px solid #ebeef5" },
          },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  "header-cell-style": {
                    backgroundColor: "#FDEFE7",
                    color: "#000000",
                  },
                  data: _vm.tableData,
                  "tooltip-effect": "dark",
                  "show-summary": "",
                  "summary-method": _vm.getSummaries,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "180",
                    prop: "id",
                    align: "center",
                    label: "收款确认单编号",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.collectionType == 4
                            ? _c(
                                "p",
                                [
                                  _c("el-tag", { attrs: { type: "success" } }, [
                                    _vm._v("自定义收款"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "blue" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editCollection(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.id))]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "180",
                    prop: "planId",
                    align: "center",
                    label: "行程编号",
                  },
                }),
                _c("el-table-column", {
                  attrs: { width: "150", align: "center", label: "下单时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormatHms")(scope.row.createTime)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "180",
                    prop: "chargingContent",
                    align: "center",
                    label: "收款内容",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "180",
                    prop: "contain",
                    align: "center",
                    label: "费用包含",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "feeAmount",
                    align: "center",
                    label: "确认单金额",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.feeAmount) +
                              _vm._s(scope.row.currency) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "70",
                    prop: "payNumber",
                    align: "center",
                    label: "付款人数",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "payPriceInCome",
                    align: "center",
                    label: "应收总金额",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "payPrice",
                    align: "center",
                    label: "实收总金额",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handlerSeeOrderClick(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.payPrice))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "refusePrice",
                    align: "center",
                    label: "退款金额",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "serviceCharge",
                    align: "center",
                    label: "手续费",
                  },
                }),
                _c("el-table-column", {
                  attrs: { width: "100", align: "center", label: "最终实收" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.payPrice -
                                  scope.row.refusePrice -
                                  scope.row.serviceCharge
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "260",
                    align: "center",
                    label: "操作",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              scope.row.currency == "￥"
                                ? _c("svg-icon", {
                                    staticStyle: { width: "0.5rem" },
                                    attrs: { iconClass: "qrCode" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.seeQrCode(scope.row)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.07rem 0.05rem" },
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlerSeeOrderClick(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("收款详情")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.07rem 0.05rem" },
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addUnderLinePay(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.collectionDetailList.length > 0
                                        ? "再次生成应收"
                                        : "生成应收"
                                    )
                                  ),
                                ]
                              ),
                              !scope.row.collectionDetailList.length > 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        padding: "0.07rem 0.05rem",
                                      },
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteCollection(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination", {
              attrs: { totalNumber: _vm.totalNumber },
              on: { loadTable: _vm.loadTable },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dialogVisible1,
                expression: "dialogVisible1",
              },
            ],
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-bottom": "0.1rem",
                  "text-align": "right",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible1 = false
                      },
                    },
                  },
                  [_vm._v("← 返回列表")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "collection-line",
                staticStyle: {
                  display: "flex",
                  "margin-bottom": "0.1rem",
                  "align-items": "end",
                },
              },
              [
                _c("div", [
                  _vm.detailListObj.totalPrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("应收总金额："),
                        _c("span", [
                          _vm._v(
                            "¥" +
                              _vm._s(_vm.detailListObj.totalPrice.toFixed(2))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("span", { staticClass: "totalPrice" }, [
                    _vm._v("待到账总金额："),
                    _c("span", [
                      _vm._v("¥" + _vm._s(_vm.detailListObj.noIncomePirce)),
                    ]),
                  ]),
                  _vm.detailListObj.incomePrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("已到账总金额："),
                        _c("span", [
                          _vm._v(
                            "¥" +
                              _vm._s(
                                (
                                  _vm.detailListObj.totalPrice -
                                  _vm.detailListObj.noIncomePirce
                                ).toFixed(2)
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailListObj.refurePrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("退款总金额："),
                        _c("span", [
                          _vm._v("¥" + _vm._s(_vm.detailListObj.refurePrice)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailListObj.refureingPrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("退款中总金额："),
                        _c("span", [
                          _vm._v(
                            "¥" + _vm._s(_vm.detailListObj.refureingPrice)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailListObj.taxPrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("手续费总金额："),
                        _c("span", [
                          _vm._v(
                            "¥" + _vm._s(_vm.detailListObj.taxPrice.toFixed(2))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailListObj.incomePrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("实收金额（到账-退款-手续费）："),
                        _c("span", [
                          _vm._v(
                            "¥" +
                              _vm._s(_vm.detailListObj.incomePrice.toFixed(2))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailListObj.waitIncomePrice > 0
                    ? _c("span", { staticClass: "totalPrice" }, [
                        _vm._v("已到账未结算总金额："),
                        _c("span", [
                          _vm._v(
                            "¥" + _vm._s(_vm.detailListObj.waitIncomePrice)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "searchDiv",
                staticStyle: { "margin-bottom": "0.1rem" },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "80px" },
                    attrs: { placeholder: "到账状态", size: "mini" },
                    model: {
                      value: _vm.detailSearchObj.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailSearchObj, "status", $$v)
                      },
                      expression: "detailSearchObj.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "已到账", value: 1 } }),
                    _c("el-option", { attrs: { label: "未到账", value: 2 } }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.serachList } },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  "header-cell-style": {
                    backgroundColor: "#FDEFE7",
                    color: "#000000",
                  },
                  data: _vm.detailList,
                  "tooltip-effect": "dark",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: { width: "150", align: "center", label: "收款时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormatHms")(scope.row.payDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "250",
                    prop: "payName",
                    align: "center",
                    label: "付款方名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "100",
                    prop: "payPrice",
                    align: "center",
                    label: "收款金额",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status != 5
                            ? _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v("¥" + _vm._s(scope.row.payPrice)),
                              ])
                            : _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("-¥" + _vm._s(scope.row.payPrice)),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { width: "100", align: "center", label: "付款方式" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.payType == 1 ? "微信" : "线下转账"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { width: "200", align: "center", label: "备注" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          !scope.row.remark || scope.row.remark == ""
                            ? _c(
                                "a",
                                {
                                  staticStyle: { color: "blue" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFile(scope.row, [
                                        "remark",
                                      ])
                                    },
                                  },
                                },
                                [_vm._v("编辑备注")]
                              )
                            : _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", width: "130", label: "是否到账" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 3 || scope.row.status == 4
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "blue" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectRefuse(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.status == 3
                                        ? "退款中"
                                        : "已退款"
                                    )
                                  ),
                                ]
                              )
                            : scope.row.status == 10
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "blue" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goTransferOutManagement(
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v("已转出")]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 1 ||
                                      scope.row.status == 5 ||
                                      scope.row.status == 6
                                      ? "已到账"
                                      : "未到账"
                                  ) + " "
                                ),
                              ]),
                          scope.row.status == 3 || scope.row.status == 4
                            ? _c("span", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      scope.row.refundPrice == 0
                                        ? scope.row.payPrice
                                        : scope.row.refundPrice
                                    )
                                ),
                              ])
                            : _vm._e(),
                          scope.row.refundDate
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormatHms")(
                                      scope.row.refundDate
                                    )
                                  ) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { width: "100", align: "center", label: "已开票金额" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.invoicePrice
                                  ? "¥" + scope.row.invoicePrice
                                  : "未开票"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.collectionToOther(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("转出")]
                              )
                            : _vm._e(),
                          scope.row.status == 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.refurePay(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("退款")]
                              )
                            : _vm._e(),
                          scope.row.status == 0 &&
                          !Number(scope.row.invoicePrice) > 0
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteDetailData(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          scope.row.status == 0
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFile(scope.row, [])
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          Number(scope.row.payPrice) -
                            Number(scope.row.invoicePrice) >
                          0
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.invoiceClick(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("开发票")]
                              )
                            : _vm._e(),
                          Number(scope.row.invoicePrice) > 0
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { padding: "0.05rem 0.05rem" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goinvoiceList(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("发票详情")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("add-under-line-pay", {
        ref: "addUnderLonePay",
        on: { getList: _vm.getList },
      }),
      _c("invoicePopup", {
        ref: "invoicePopup",
        attrs: {
          detailId: _vm.detailId,
          orderList: _vm.detailList.map((n) => ({
            ...n,
            payPrice: n.payPrice - n.refundPrice,
          })),
          state: 1,
        },
        on: {
          update: function ($event) {
            return _vm.getList($event)
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认单收款二维码",
            visible: _vm.dialogVisible3,
            "append-to-body": true,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible3 = $event
            },
          },
        },
        [
          _vm.text
            ? _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticClass: "erWeimaBox" },
                  [
                    _c("Qr", {
                      staticStyle: {
                        "text-align": "center",
                        display: "flex",
                        "margin-left": "120px",
                      },
                      attrs: {
                        bgSrc: _vm.bgSrc,
                        logoSrc: _vm.logoSrc,
                        text: _vm.text,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible3 = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("collection-new", {
        ref: "addCollection",
        on: { refresh: _vm.getList },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款申请",
            visible: _vm.dialogVisible2,
            "append-to-body": true,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
          },
        },
        [
          _c("div", { staticClass: "payRequestContent" }, [
            _vm.refuceObj.payType == 2
              ? _c("div", [
                  _c(
                    "p",
                    [
                      _c("span", [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("收款方名称  "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        model: {
                          value: _vm.refuceObj.payName,
                          callback: function ($$v) {
                            _vm.$set(_vm.refuceObj, "payName", $$v)
                          },
                          expression: "refuceObj.payName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c("span", [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("收款银行名称  "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        model: {
                          value: _vm.refuceObj.payBankName,
                          callback: function ($$v) {
                            _vm.$set(_vm.refuceObj, "payBankName", $$v)
                          },
                          expression: "refuceObj.payBankName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c("span", [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("收款账户  "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        model: {
                          value: _vm.refuceObj.payBankNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.refuceObj, "payBankNumber", $$v)
                          },
                          expression: "refuceObj.payBankNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "p",
              [
                _c("span", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v("退款金额  "),
                ]),
                _c("el-input", {
                  attrs: { placeholder: "请输入内容" },
                  model: {
                    value: _vm.refuceObj.price,
                    callback: function ($$v) {
                      _vm.$set(_vm.refuceObj, "price", $$v)
                    },
                    expression: "refuceObj.price",
                  },
                }),
              ],
              1
            ),
            _c(
              "p",
              [
                _c("span", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v("退款原因  "),
                ]),
                _c("el-input", {
                  attrs: { placeholder: "请输入内容" },
                  model: {
                    value: _vm.refuceObj.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.refuceObj, "remark", $$v)
                    },
                    expression: "refuceObj.remark",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible2 = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.refuceSure } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款查询",
            visible: _vm.refuseSelectDialiog,
            "append-to-body": true,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.refuseSelectDialiog = $event
            },
          },
        },
        [
          _c("refuse-request", {
            ref: "refuseRequest",
            attrs: { isDialog: true },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "收款转出",
            visible: _vm.collectionToOtherDialog,
            "append-to-body": true,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.collectionToOtherDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "payRequestContent" }, [
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.zhuanRadio,
                      callback: function ($$v) {
                        _vm.zhuanRadio = $$v
                      },
                      expression: "zhuanRadio",
                    },
                  },
                  [_vm._v("转出到其他团")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: 2 },
                    model: {
                      value: _vm.zhuanRadio,
                      callback: function ($$v) {
                        _vm.zhuanRadio = $$v
                      },
                      expression: "zhuanRadio",
                    },
                  },
                  [_vm._v("转出到余额钱包")]
                ),
              ],
              1
            ),
            _vm.zhuanRadio == 1
              ? _c(
                  "div",
                  [
                    _c(
                      "p",
                      [
                        _vm._v("请输入你要转出的团号："),
                        _c("el-input", {
                          staticStyle: { width: "100px", "margin-top": "10px" },
                          attrs: { size: "mini" },
                          on: { change: _vm.changeZhuanPlanId },
                          model: {
                            value: _vm.zhuanPlanId,
                            callback: function ($$v) {
                              _vm.zhuanPlanId = $$v
                            },
                            expression: "zhuanPlanId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.zhuanPlanObj && _vm.zhuanPlanObj.id
                      ? _c("plan-list-info", {
                          attrs: { item: _vm.zhuanPlanObj, isLook: true },
                        })
                      : _vm._e(),
                    _vm.zhuanPlanObj && !_vm.zhuanPlanObj.id
                      ? _c(
                          "p",
                          {
                            staticStyle: { color: "red", "font-size": "18px" },
                          },
                          [_vm._v("查询不到你输入的团信息，请重新输入")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "p",
              [
                _c("el-input", {
                  staticStyle: { width: "400px", "margin-top": "10px" },
                  attrs: { size: "mini", placeholder: "请输入转出理由" },
                  model: {
                    value: _vm.zhuanRemark,
                    callback: function ($$v) {
                      _vm.zhuanRemark = $$v
                    },
                    expression: "zhuanRemark",
                  },
                }),
              ],
              1
            ),
            _c("p", { staticStyle: { color: "red" } }, [
              _vm._v("注：请仔细核对信息是否正确，一旦转出不可修改"),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible2 = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.collectionToOtherSure },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footTitleLeft" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("收款订单列表（我的收入）")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }